var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJiffyPointsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343,
    height: 205,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8EAFF",
    d: "m107.97 66.188 104.605 22.234c.754 5.803 5.061 10.762 11.091 12.044 6.03 1.281 11.982-1.496 15.031-6.491l104.028 22.112-6.192 29.13c-6.737-.23-12.88 4.413-14.335 11.26-1.456 6.847 2.268 13.586 8.516 16.116l-6.701 31.527-104.028-22.112c-.754-5.803-5.062-10.761-11.092-12.042-6.029-1.282-11.981 1.495-15.03 6.49L89.258 154.221l6.7-31.522c6.746.24 12.9-4.404 14.357-11.259 1.457-6.854-2.276-13.6-8.536-16.124l6.191-29.128Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE2AD",
    d: "m216.536 96.798-167.81 67.799-22.11-9.327L.343 90.238 9.767 68.17 177.577.37l22.11 9.328 26.274 65.032-9.425 22.068Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F44719",
    d: "M303.091 92.592c-2.081-19.804-13.941-36.364-30.619-45.901l-1.27-12.083L59.674 56.84l1.27 12.083c-14.33 12.797-22.49 31.447-20.407 51.265 2.082 19.804 13.94 36.351 30.62 45.901l1.27 12.083 211.527-22.232-1.27-12.083c14.33-12.81 22.489-31.46 20.407-51.265Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiffyPointsEmpty);
export default __webpack_public_path__ + "static/media/jiffy-points-empty.1dcdb0f08fc8019fc50889b9206e1a33.svg";
export { ForwardRef as ReactComponent };